/**
 * Lieu d'intervention possible pour un panier de prestations (2026-09-24, Emeni : « lieu configurable
 * par prestation »).
 *
 * L'établissement déclare où il intervient ; chaque prestation peut restreindre ce choix. Une coupe se
 * fait au salon, un lissage peut se faire à domicile — le réglage global ne suffisait pas à le dire.
 * Une prestation sans réglage suit l'établissement, ce qui est le défaut.
 *
 * Même règle que côté serveur (modeLieuEffectif dans [[path]].js), y compris le repli : si les
 * prestations choisies sont incompatibles entre elles, on retombe sur le mode de l'établissement
 * plutôt que de laisser le visiteur devant un formulaire sans issue.
 */
export type ModeLieu = 'domicile' | 'entreprise' | 'les_deux';
export type ModeLieuPrestation = ModeLieu | '';

const LIEUX: Record<ModeLieu, ReadonlyArray<'domicile' | 'entreprise'>> = {
    domicile: ['domicile'],
    entreprise: ['entreprise'],
    les_deux: ['domicile', 'entreprise'],
};

const normaliser = (v: unknown): ModeLieuPrestation =>
    (v === 'domicile' || v === 'entreprise' || v === 'les_deux' ? v : '');

const lieuxDuMode = (mode: unknown) => LIEUX[(normaliser(mode) || 'domicile') as ModeLieu];

export const modeLieuEffectif = (
    modeEtablissement: unknown,
    prestations: ReadonlyArray<{ location_mode?: unknown }>,
): ModeLieu => {
    let lieux = [...lieuxDuMode(modeEtablissement)];
    for (const p of prestations) {
        const propre = normaliser(p?.location_mode);
        if (!propre) continue;
        const restreint = lieux.filter((l) => lieuxDuMode(propre).includes(l));
        if (!restreint.length) return lieuxDuMode(modeEtablissement).length >= 2 ? 'les_deux' : lieuxDuMode(modeEtablissement)[0];
        lieux = restreint;
    }
    return lieux.length >= 2 ? 'les_deux' : lieux[0];
};
